import Vue from 'vue';
import { Customer } from './Customer';
import { IconName } from 'JS/constants/icons';
import { ILocalStoreJson } from './LocalStore';
import { IQuickCartSummaryJson } from './Order';

export interface IHeaderJson  {
	cartSummaryJson?: IQuickCartSummaryJson;
	customerHasRegistries: boolean;
	customer?: Customer;
	customerRegion?: string;
	customerName: string;
	deptMenu: IWebSiteMenu[];
	googleApiKey: string;
	headerAds: IHeaderAd[];
	headerLinks: HeaderLink[];
	init: boolean;
	isMobileDevice: boolean;
	itemsInCartCount: number;
	localStoreName: string;
	localStoreJson?: ILocalStoreJson;
	loggedIn: boolean;
	greeting: string;
}

//Used for the scrolling site messenger
export interface IHeaderAd {
	text: string;
	link?: string;
	icon: IconName;
	endDateTime: string,
	countdown: HeaderAdCountdown;
}

export interface HeaderLink {
	text: string,
	link: string,
}

export enum HeaderAdCountdown {
	"None" = 0,
	"After" = 1,
	"Before" = 2,
};

export interface IWebSiteMenu {
	id: string;
	bannerImageUrl: string;
	bannerLinkUrl: string;
	imageUrl: string;
	hasShowMoreLink: boolean;
	children: IWebSiteMenu[];
	name: string;
	url: string;
	limit: number;
	hierLevel: number;
	linkType: MenuLinkType;
}

export interface IManagedMenu extends Vue {
	menuId: string;
	hide(): void;
}

export type MenuLinkType = "featured" | "category" | "other";
